"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var store_1 = require("@ngrx/store");
var skynet_store_currencies_api_1 = require("@synisys/skynet-store-currencies-api");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var operators_1 = require("rxjs/operators");
var Subject_1 = require("rxjs/Subject");
var currency_control_state_1 = require("../../currency-control.state");
var utilities_1 = require("../../utilities");
var LOGGER = utilities_1.createLogger('sis-currency-combo');
var SisCurrencyComboComponent = /** @class */ (function () {
    function SisCurrencyComboComponent(store, cd) {
        this.store = store;
        this.cd = cd;
        this.currencyIdChange = new core_1.EventEmitter();
        this.destroy = new Subject_1.Subject();
        this._currencyControlState = new currency_control_state_1.CurrencyControlState(store);
    }
    Object.defineProperty(SisCurrencyComboComponent.prototype, "currencyControlState", {
        set: function (value) {
            this._currencyControlState = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisCurrencyComboComponent.prototype, "currencyId", {
        get: function () {
            return this._currencyId;
        },
        set: function (currencyId) {
            if (this._currencyId === currencyId) {
                return;
            }
            if (skynet_store_utilities_1.notNil(this._currencyId)) {
                this.currencyIdChange.emit(currencyId);
                this._currencyControlState.updateCurrency(currencyId);
            }
            this._currencyId = currencyId;
        },
        enumerable: true,
        configurable: true
    });
    SisCurrencyComboComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.currencies$ = skynet_store_currencies_api_1.currencyStoreManager
            .selectAll(this.store)
            .pipe(operators_1.map(function (value) { return value.toList(); }));
        this._currencyControlState
            .getMoney()
            .pipe(operators_1.takeUntil(this.destroy))
            .subscribe(function (value) {
            if (skynet_store_utilities_1.notNil(value.currencyId)) {
                _this.currencyId = value.currencyId;
                _this.cd.detectChanges();
            }
            _this.currencyIdChange.emit(value.currencyId);
        }, function (e) { return LOGGER.error(e); });
    };
    SisCurrencyComboComponent.prototype.ngOnDestroy = function () {
        this.destroy.next();
        this.destroy.complete();
    };
    SisCurrencyComboComponent.prototype.trackByCurrency = function (index, currency) {
        return currency.id;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisCurrencyComboComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", currency_control_state_1.CurrencyControlState),
        __metadata("design:paramtypes", [currency_control_state_1.CurrencyControlState])
    ], SisCurrencyComboComponent.prototype, "currencyControlState", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], SisCurrencyComboComponent.prototype, "currencyId", null);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], SisCurrencyComboComponent.prototype, "currencyIdChange", void 0);
    SisCurrencyComboComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-currency-combo',
            template: require('./sis-currency-combo.component.html'),
            styles: [require('./sis-currency-combo.component.css')],
            changeDetection: core_1.ChangeDetectionStrategy.OnPush,
        }),
        __metadata("design:paramtypes", [store_1.Store,
            core_1.ChangeDetectorRef])
    ], SisCurrencyComboComponent);
    return SisCurrencyComboComponent;
}());
exports.SisCurrencyComboComponent = SisCurrencyComboComponent;
//# sourceMappingURL=sis-currency-combo.component.js.map